var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadReady)?_c('mdb-select',{attrs:{"multiple":true,"options":_vm.labelOptions,"visibleOptions":4,"icon":"list","label":_vm.$t('notification_group'),"placeholder":_vm.$t('choose_group')},on:{"getValue":_vm.getSelectValue}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }